import React, {useEffect, useState, useCallback} from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';

const ErrorPage = () => {
    const { t } = useTranslation('common');  
    return (
        <Container className="dashboard">
            <Row className="category-sales">
            <Col sm="12">
                <Card className="pb-3">
                    <CardBody className="min-w-50 p-3">
                        <div className="card__title mb-2">
                            <h5 className="bold-text card__title-center">Not Implemented.</h5>
                        </div>
                        </CardBody>
              </Card>
          </Col>                   
      </Row>
      </Container>
    );
}

export default ErrorPage